/**
 * §21.7 (E38) — the value that means "do not convert".
 *
 * Here rather than in the registry beside the setting itself, and here rather
 * than in `portal-kit`, for the reason `locales.ts` gives about the shipped
 * language list: three things read it and only two of them are browsers. Both
 * consoles offer it as the first option in a picker, and `api-core` accepts it
 * where it would refuse any other non-currency. A sentinel the API knows and a
 * picker does not is a control that saves something the reader cannot choose
 * again; the other way round is a picker offering something the API refuses.
 *
 * A sentinel rather than an absent value, because this registry gives absence a
 * different meaning: `platformDefault: undefined` is "there is deliberately no
 * default, and §4.3a makes its absence a loud failure". Not converting is not a
 * missing answer — it is the answer, and the conservative one — so it has to be
 * a value the resolver can return, audit and show on a settings screen.
 *
 * Not a currency code, so it can never be confused for one: `currency_code` is
 * three to ten uppercase letters (0001) and every real code is three or four.
 * That it still fits inside that shape is what lets `users.display_currency`
 * and `affiliate_identities.display_currency` (0153) hold it under one CHECK.
 */
export const DISPLAY_CURRENCY_ORIGINAL = 'ORIGINAL';
//# sourceMappingURL=display-currency.js.map